<template>
  <div class="agency-location set-after">
    <div class="col-twelve set-after no-padding-left no-padding-right">
      <label :for="'title-' + this.location.id">Title</label>
      <input type="text" class="long-input" :id="'title-' + this.location.id"
             :name="'locations[' + this.location.id + '][title]'" required v-model="title">
    </div>
    <div class="col-twelve set-after no-padding-left no-padding-right">
      <label :for="'website-' + this.location.id">Website (optional)</label>
      <input type="text" class="long-input" :id="'website-' + this.location.id"
             :name="'locations[' + this.location.id + '][website]'" v-model="website">
    </div>
    <div class="col-six set-after no-padding-left phone-number">
      <label :for="'phone-' + this.location.id">Phone</label>

      <div class="select-wrapper">
        <select :id="'phone-code-id-' + this.location.id" :name="'locations[' + this.location.id + '][phone_code]'"
                v-model="phoneCode">
          <option v-for="country in sortedCountriesByCode" :value="country.phone_code">
            {{ country.phone_code ? country.code + '(+' + country.phone_code + ')' : '' }}
          </option>
        </select>
      </div>

      <input type="text" class="long-input" :id="'phone-' + this.location.id"
             :name="'locations[' + this.location.id + '][phone]'" required v-model="phone">
    </div>
    <div class="col-six set-after no-padding-right">
      <label :for="'skype-' + this.location.id">Skype (optional)</label>
      <input type="text" class="long-input" :id="'skype-' + this.location.id"
             :name="'locations[' + this.location.id + '][skype]'" v-model="skype">
    </div>
    <div class="col-twelve set-after no-padding-left no-padding-right">
      <label :for="'address-first-line-' + this.location.id">Address first line</label>
      <input type="text" class="long-input" :id="'address-first-line-' + this.location.id"
             :name="'locations[' + this.location.id + '][address_fl]'" required v-model="address_fl">
    </div>
    <div class="col-twelve set-after no-padding-left no-padding-right">
      <label :for="'address-second-line-' + this.location.id">Address second line (optional)</label>
      <input type="text" class="long-input" :id="'address-second-line-' + this.location.id"
             :name="'locations[' + this.location.id + '][address_sl]'" v-model="address_sl">
    </div>
    <div class="col-six set-after no-padding-left">
      <label :for="'city-' + this.location.id">City</label>
      <input type="text" class="long-input" :id="'city-' + this.location.id"
             :name="'locations[' + this.location.id + '][city]'" required v-model="city">
    </div>
    <div class="col-six set-after no-padding-right">
      <label :for="'state-' + this.location.id">State (optional)</label>
      <input type="text" class="long-input" :id="'state-' + this.location.id"
             :name="'locations[' + this.location.id + '][state]'" v-model="state">
    </div>
    <div class="col-six set-after no-padding-left">
      <label :for="'zip-' + this.location.id">Zip / Postcode</label>
      <input type="text" class="long-input" :id="'zip-' + this.location.id"
             :name="'locations[' + this.location.id + '][zip]'" required v-model="zip">
    </div>
    <div class="col-six set-after no-padding-right">
      <div class="select-wrapper">
        <label :for="'country-id-' + this.location.id">Country</label>
        <select :id="'country-id-' + this.location.id" :name="'locations[' + this.location.id + '][country_id]'"
                @change="changeCountry()"
                v-model="countryId" class="long-input" required>
          <option v-for="country in sortedCountriesByName" :value="country.id">{{ country.name }}</option>
        </select>
      </div>
    </div>
    <div class="col-six set-after no-padding-left">
      <label :for="'email-' + this.location.id">Email (optional)</label>
      <input type="text" class="long-input" :id="'email-' + this.location.id"
             :name="'locations[' + this.location.id + '][email]'" v-model="email">
    </div>
    <div class="col-six set-after no-padding-right">
      <div class="select-wrapper">
        <label :for="'hide_option-' + this.location.id">Hide Info</label>

        <select :id="'hide_option-' + this.location.id" class="long-input"
                :name="'locations[' + this.location.id + '][hide_option]'" v-model="hideOption">
          <option :value="0">None</option>
          <option :value="1">Address</option>
          <option :value="2">Phone</option>
          <option :value="3">Address &amp; Phone</option>
        </select>
      </div>
    </div>
    <div class="col-full align-center">
      <button type="button" class='transparent-button' @click="deleteLocation">Delete location</button>
    </div>
  </div>
</template>

<script>
// Component for showing locations form

export default {
  props: ['location', 'countries'],
  data() {
    return {
      website: null,
      phone: null,
      skype: null,
      address_fl: null,
      address_sl: null,
      city: null,
      state: null,
      zip: null,
      countryId: 1,
      phoneCode: '',
      title: null,
      email: null,
      hideOption: 0,
      sortedCountriesByName: [],
      sortedCountriesByCode: [],
      mostPopularCodes: ['US', 'GB']
    };
  },

  mounted() {
    if (this.location['zip']) {
      this.website = this.location['website'];
      this.phone = this.location['phone'];
      this.phoneCode = this.location['phone_code'] ? this.location['phone_code'] : null;
      this.skype = this.location['skype'];
      this.address_fl = this.location['address_fl'];
      this.address_sl = this.location['address_sl'];
      this.city = this.location['city'];
      this.state = this.location['state'];
      this.zip = this.location['zip'];
      this.countryId = this.location['country_id'];
      this.email = this.location['email'];
      this.title = this.location['title'];
      this.hideOption = this.location['hide_option'];
    }

    this.sortedCountriesByName = this.prepareSortCountries('name');

    this.sortedCountriesByCode = this.prepareSortCountries('code');

    this.mostPopularCodes.forEach((code) => {
      let selectedCountry = this.countries.filter((country) => {
        return country.code === code;
      })[0];

      this.sortedCountriesByName.unshift(selectedCountry);
      this.sortedCountriesByCode.unshift(selectedCountry);
    });
  },

  methods: {
    deleteLocation() {
      this.$emit('locationDeleted', {
        id: this.location['id']
      });
    },

    changeCountry() {
      let selectedCountry = this.sortedCountriesByName.filter((country) => {
        return country.id === this.countryId;
      })[0];

      if (selectedCountry.phone_code) {
        this.phoneCode = selectedCountry.phone_code;
      }
    },

    prepareSortCountries(type) {
      let countries = Vue.util.extend([], this.countries);

      countries = countries.sort(this[type === 'name' ? 'sortCompareCountryName' : 'sortCompareCountryCode']);

      let otherCountry = countries.filter((country) => {
        return country.code === 'Other' || !country.phone_code;
      })[0];

      countries.splice(countries.indexOf(otherCountry), 1);

      countries.push(otherCountry);

      return countries;
    },

    sortCompareCountryName(a, b) {
      if (a.name < b.name) return -1;

      if (a.name > b.name) return 1;

      return 0;
    },

    sortCompareCountryCode(a, b) {
      if (a.code < b.code) return -1;

      if (a.code > b.code) return 1;

      return 0;
    }
  }
};
</script>

<style lang="scss" scoped>
  .agency-location {
    border-top: 1px solid #dddddd;
    padding-top: 15px;
    margin-top: 15px;
  }

  .agency-location:first-child {
    border-top: 0;
    padding-top: 0;
    margin-top: 0;
  }

  .phone-number {
    .select-wrapper {
      width: 25%;
      display: inline-block;
      top: -12px;
    }

    input {
      width: 70%;
      display: inline-block;
    }
  }
</style>